import React from 'react';
import { useNavigate } from 'react-router-dom';
import GamePrice from './GamePrice';

function FeaturedGame({ game, isOwned = false }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/game/${game.id}`);
  };

  return (
    <div className="w-full mb-8">
      <div 
        onClick={handleClick}
        onContextMenu={(e) => e.preventDefault()}
        className="bg-transparent border border-dark-border rounded-3xl overflow-hidden shadow-xl group cursor-pointer transition-all duration-300 hover:shadow-2xl hover:shadow-accent-blue/20 relative select-none"
      >
        <div className="w-full aspect-[16/9] max-h-[450px] relative overflow-hidden rounded-3xl select-none">
          {game.featuredImage ? (
            <img 
              src={game.featuredImage} 
              alt={game.title}
              draggable={false}
              onDragStart={(e) => e.preventDefault()}
              className="w-full h-full object-cover select-none"
            />
          ) : (
            <div className="w-full h-full bg-gradient-to-br from-dark-border via-dark-card to-dark-surface flex items-center justify-center">
              <div className="font-sans text-sm text-white/40 font-normal">Game Image</div>
            </div>
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/10 to-transparent pointer-events-none"></div>
          <div className="absolute bottom-0 left-0 right-0 p-4 md:p-8 z-10 pointer-events-none">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-4">
              <div className="pointer-events-auto">
                <h2 className="font-semibold text-xl md:text-3xl text-white mb-2 drop-shadow-[0_2px_8px_rgba(0,0,0,0.8)] select-none">{game.title}</h2>
                <p className="font-normal text-sm md:text-base text-white/95 mb-2 md:mb-4 drop-shadow-[0_2px_6px_rgba(0,0,0,0.7)] select-none">{game.developer}</p>
              </div>
              <div className="flex items-center gap-2 pointer-events-auto">
                <div className="bg-dark-surface/40 backdrop-blur-sm border border-dark-border/50 rounded-xl px-4 md:px-6 py-2 md:py-3 select-none">
                  <GamePrice game={game} isOwned={isOwned} size="lg" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FeaturedGame;

